/**
 * safeHref(u) — returns `u` only when it is an http(s), mailto: or tel: URL,
 * otherwise `undefined`. Use for every href built from user- or API-supplied
 * data so `javascript:` / `data:` URLs can never become clickable links.
 *
 *   <a href={safeHref(client.website)}>…</a>
 *
 * Bare domains ("example.com") are not upgraded — call `safeHref(withScheme(u))`
 * if you want that.
 */
const ALLOWED = /^(https?:|mailto:|tel:)/i;

export function safeHref(u) {
  if (u == null) return undefined;
  const s = String(u).trim();
  if (!s) return undefined;
  // Strip control chars / whitespace browsers ignore when parsing the scheme.
  // eslint-disable-next-line no-control-regex
  const probe = s.replace(/[\u0000-\u001F\u007F\s]+/g, '');
  if (!ALLOWED.test(probe)) return undefined;
  return s;
}

/** "example.com" → "https://example.com"; leaves anything with a scheme untouched. */
export function withScheme(u) {
  if (u == null) return u;
  const s = String(u).trim();
  if (!s || /^[a-z][a-z0-9+.-]*:/i.test(s)) return s;
  return `https://${s}`;
}

export default safeHref;
